const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchProfileMe = async (currency = "AUD") => {
  const token = localStorage.getItem("jwtToken");
  const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/me?currency=${currency}`;

  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(apiUrl, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      message: "Failed to fetch profile",
    }));
    throw new Error(errorData.message || "Failed to fetch profile");
  }

  return response.json();
};
